import {Component, DoCheck, Input, OnDestroy, OnInit} from '@angular/core';
import {Indicadores} from './tienda.component';
import {PlanAccionModel} from '../models/plan.accion.model';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {SemanaModel} from '../models/semana.model';
import {PlanAccionServices} from '../services/plan.accion.services';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {forkJoin, Subscription} from 'rxjs';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {ActivatedRoute} from '@angular/router';
import {VIEWIMAGE} from '../../variables';

@Component({
  selector: 'plan-accion',
  templateUrl: '../templates/tiendas/plan.accion.template.html'
})
export class PlanAccionComponent implements OnInit, DoCheck, OnDestroy {

  @Input()
  indTienda: Indicadores;

  isCollapse: boolean = true;

  subs: Subscription[] = [];


  planAccion: PlanAccionModel = new PlanAccionModel();


  @Input()
  empleado: EmpleadoModel;

  @Input()
  semana: SemanaModel;

  ventaPerdida: number = 0;

  constructor(private ps: PlanAccionServices, private spinner: NgxSpinnerService) {

  }

  ngOnDestroy(): void {
    this.subs.map(s => {
      s.unsubscribe();
    });
  }

  ngDoCheck(): void {

    this.planAccion.indicador = +this.empleado.indMejorar;
    this.planAccion.ventaEmpleado = this.empleado.indicadores.venta;
    this.planAccion.ventaTienda = this.indTienda.venta;

    switch (this.planAccion.indicador) {
      case 1:
        this.planAccion.nombreInd = 'Ticket Promedio';
        this.planAccion.valorIndicador = this.empleado.indicadores.ticketPromedio;
        this.planAccion.valorTienda = this.indTienda.ticketPromedio;
        this.ventaPerdida = this.ps.calcularVentaPerdida(this.indTienda.ticketPromedio, this.empleado.indicadores.venta, this.empleado.indicadores.ticketPromedio);

        break;
      case 2:
        this.planAccion.nombreInd = 'Articulo x Ticket';
        this.planAccion.valorIndicador = this.empleado.indicadores.articulosTicket;
        this.planAccion.valorTienda = this.indTienda.articulosTicket;
        this.ventaPerdida = this.ps.calcularVentaPerdida(this.indTienda.articulosTicket, this.empleado.indicadores.venta, this.empleado.indicadores.articulosTicket);

        break;
      case 3:
        this.planAccion.nombreInd = 'Ticket x Dia';
        this.planAccion.valorIndicador = this.empleado.indicadores.ticketxDia;
        this.planAccion.valorTienda = this.indTienda.ticketxDia;
        this.ventaPerdida = this.ps.calcularVentaPerdida(this.indTienda.ticketxDia, this.empleado.indicadores.venta, this.empleado.indicadores.ticketxDia);
        break;
      case 4:
        this.planAccion.nombreInd = 'Venta x Dia';
        this.planAccion.valorIndicador = this.empleado.indicadores.ventaxDia;
        this.planAccion.valorTienda = this.indTienda.ventaxDia;
        this.ventaPerdida = this.ps.calcularVentaPerdida(this.indTienda.ventaxDia, this.empleado.indicadores.venta, this.empleado.indicadores.ventaxDia);
        break;
    }
  }


  ngOnInit(): void {
    this.planAccion.tienda = this.semana.tienda;
    this.planAccion.semana = this.semana.fecha;
    this.planAccion.empleado = this.empleado.id;
    this.planAccion.indicador = this.empleado.indMejorar;


    switch (this.planAccion.indicador) {
      case 1:
        this.planAccion.nombreInd = 'Ticket Promedio';
        this.planAccion.valorIndicador = this.empleado.indicadores.ticketPromedio;
        this.planAccion.valorTienda = this.indTienda.ticketPromedio;
        break;
      case 2:
        this.planAccion.nombreInd = 'Articulo x Ticket';
        this.planAccion.valorIndicador = this.empleado.indicadores.articulosTicket;
        this.planAccion.valorTienda = this.indTienda.articulosTicket;
        break;
      case 3:
        this.planAccion.nombreInd = 'Ticket x Dia';
        this.planAccion.valorIndicador = this.empleado.indicadores.ticketxDia;
        this.planAccion.valorTienda = this.indTienda.ticketxDia;
        break;
      case 4:
        this.planAccion.nombreInd = 'Venta x Dia';
        this.planAccion.valorIndicador = this.empleado.indicadores.ventaxDia;
        this.planAccion.valorTienda = this.indTienda.ventaxDia;
        break;
    }


    this.subs.push(this.ps.getPlanAccion(this.planAccion.empleado, this.planAccion.semana).subscribe(d => {

      if (d.data.planAccion != null) {
        let dp = d.data.planAccion;
        this.planAccion.actividadMejoramiento = dp.actividadMejoramiento;
        this.planAccion.comentario = dp.comentario;
        this.planAccion.indicador = dp.indicador;
        this.planAccion.nombreInd = dp.nombreInd;
        this.planAccion.id = dp.id;
        this.planAccion.valorIndicador = dp.valorIndicador;
        this.planAccion.valorTienda = dp.valorTienda;
        this.planAccion.estado = dp.estado;
        this.planAccion.ventaEmpleado = dp.ventaEmpleado;
        this.planAccion.ventaTienda = dp.ventaTienda;

        this.empleado.indMejorar = +this.planAccion.indicador;


        console.log(`empleado ${this.empleado.nombre}, indicador a mejorar ${this.empleado.indMejorar}`);

      }

    }));

    this.subs.push(this.ps.obsHistoricoPlan.subscribe(d => {
      // console.log(d);
    }));

    this.ps.getHistoricoPlanAccion(this.planAccion.empleado, this.planAccion.semana);


  }


  guardarPlanAccion() {
    console.log(this.empleado.indMejorar);
    console.log(this.planAccion);
    this.spinner.show();
    if (this.planAccion.id != undefined && this.planAccion.estado.cerrado == 0) {
      this.subs.push(this.ps.updatePlanAccion(this.planAccion).subscribe(d => {
        console.log(d);
        this.spinner.hide();
      }));
    } else {
      this.subs.push(this.ps.addPlanAccion(this.planAccion).subscribe(d => {
        console.log(d);
        this.spinner.hide();
      }));
    }
  }
}

@Component({
  selector: 'lista-planes',
  templateUrl: '../templates/tiendas/lista.plan.accion.template.html'
})
export class ListaPlanAccionComponent implements OnInit {

  planes: PlanAccionModel[] = [];
  tiendas: TiendaEntity[] = [];

  empleados: EmpleadoModel[] = [];

  rows: any[] = [];
  tempRows: any[] = [];

  filtTienda: string = '';
  filtPeriodo: string = '';

  columns = [
    {name: 'Empleado'},
    {name: 'Tienda'},
    {name: 'Semana'},
    {name: 'Estado'},
    {name: 'Acciones'}
  ];

  constructor(private ps: PlanAccionServices, private ts: TiendaServices, private es: EmpleadoServices, private spiner: NgxSpinnerService) {

  }

  ngOnInit(): void {
    this.spiner.show();

    // let consultas:any[] = [];
    //
    // consultas.push(this.ps.getAllPlanAccion());
    // consultas.push(this.ts.getAllTiendas());
    //
    // forkJoin(consultas).subscribe(d=>{
    //   console.log(d);
    //   this.planes = d[0].data.planesAccion;
    //   this.tiendas = d[1].data.tiendas;
    //   this.spiner.hide();
    // });

    this.ts.getAllTiendas().subscribe(d => {
      console.log(d);
      this.tiendas = d.data.tiendas;

      let ids: string[] = [];

      this.tiendas.map(t => {
        ids.push(t.idDB);
      });

      this.ps.getAllPlanAccion(ids).subscribe(pd => {
        console.log(pd);
        this.planes = pd.data.planesAccion;

        let eIds: string[] = [];

        this.planes.map(p => {
          eIds.push(p.empleado);
        });

        this.es.devolverEmpleados(eIds).subscribe(ed => {
          console.log(ed);
          this.empleados = ed.data.devolverEmpleados;
          this.spiner.hide();
          this.crearTablaPlanes();
        });

      });

    });

  }

  crearTablaPlanes() {
    this.rows = [];

    for (let p of this.planes) {
      let t = this.tiendas.find(t => t.idDB == p.tienda);
      let e = this.empleados.find(e => e.id == p.empleado);

      let estado = '';

      if (p.estado.completado)
        estado = 'Completado';
      else if (p.estado.cerrado)
        estado = 'Cerrado';
      else if (p.estado.activo)
        estado = 'Activo';

      this.rows.push({
        empleado: e.nombre,
        tienda: t.nombre,
        semana: p.semana,
        estado: estado,
        acciones: p.id
      });

      this.rows = [...this.rows];
      this.tempRows = [...this.rows];
    }
  }

  filtrarTiendas() {
    console.log('filtrando');
    const temp = this.tempRows.filter(e => {
      let f1 = e.tienda.toLowerCase().indexOf(this.filtTienda.toLowerCase());

      if (f1 == -1)
        return false;

      let f2 = e.semana.toLowerCase().indexOf(this.filtPeriodo.toLowerCase());

      return f2 != -1;

    });

    this.rows = [...temp];
  }

}


@Component({
  selector: 'ver-plan-accion',
  templateUrl: '../templates/tiendas/ver.plan.accion.template.html'
})
export class VerPlanAccionComponent implements OnInit {

  plan: PlanAccionModel;
  tienda: TiendaEntity;
  empleado: EmpleadoModel;
  fileToUpload: File = null;
  pathImg: string = '';
  estado: string = '';
  ventaPerdida: number = 0;

  constructor(private ps: PlanAccionServices, private ts: TiendaServices, private es: EmpleadoServices, private activeRouter: ActivatedRoute, private spinner: NgxSpinnerService) {
    this.pathImg = VIEWIMAGE;
  }

  ngOnInit(): void {
    let id = this.activeRouter.snapshot.params.id;

    this.spinner.show();

    this.ps.getPlanAccionxID(id).subscribe(d => {
      console.log(d.data.planAccionxId);
      this.plan = d.data.planAccionxId;

      if (this.plan.estado.cerrado) {
        if (this.plan.estado.completado)
          this.estado = 'Plan Completado';
        else
          this.estado = 'Plan no Completado';
      } else if (this.plan.estado.activo)
        this.estado = 'Plan Activo';

      let consultas: any[] = [];

      consultas.push(this.ts.getTienda(this.plan.tienda));
      consultas.push(this.es.devolverEmpleado(this.plan.empleado));

      forkJoin(consultas).subscribe((dt: any) => {
        console.log(dt);
        this.tienda = dt[0].data.tienda;
        this.empleado = dt[1].data.devolverEmpleado;
        this.ventaPerdida = this.ps.calcularVentaPerdida(this.plan.valorTienda, this.plan.ventaEmpleado, this.plan.valorIndicador);
        this.spinner.hide();
      });
    });

  }

  handleFile(files: FileList) {
    console.log(files);
    this.fileToUpload = files.item(0);
  }

  guardarPlanAccion() {

    if (this.fileToUpload != undefined) {
      this.spinner.show();
      this.ps.subirImagen(this.fileToUpload).subscribe(d => {
        console.log(d);
        this.plan.archivo = d.nombre;

        console.log(this.plan);
        this.ps.updatePlanAccion(this.plan).subscribe(d => {
          console.log(d);
          this.spinner.hide();
        });
      });
    } else {
      if (this.plan.retroalimentacion) {
        this.spinner.show();
        this.ps.updatePlanAccion(this.plan).subscribe(d => {
          console.log(d);
          this.spinner.hide();
        });
      }
    }

  }
}
